/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

const price = document.getElementsByClassName('lb-upsell-money-2');

$(function () {
  $('.cart-item-final-line-price').append("(税抜)");
  $('.cart-item-original-line-price').append("(税抜)");

  $("#_ngc_stock_notice_btn").text("入荷通知を受け取る");
  $('.ngc__modal__companyName').hide();

  const hideFilterItems = () => {
    const hiddenWords = [
      'Appify:DisableSoldOutUI',
      'Appify:Restock',
      'Appify:No-restock',
      'no-restock',
      're-stock',
      'POINTx10',
      'quick_wipes_pack',
      'メール便'
    ];

    $('.facets__item, .facets__list li, li').each(function () {
      const text = $(this).text().trim();

      if (hiddenWords.some(word => text.includes(word))) {
        $(this).hide();
      }
    });
  };

  hideFilterItems();

  // Shopifyの絞り込みは後から再描画されることがあるので監視
  const observer = new MutationObserver(function () {
    hideFilterItems();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
/*
// 期間表示設定はここから　【予約】
document.addEventListener("DOMContentLoaded", function () {

    ///***設定値*********************************************

    //設定のオンオフ
    var check_flg = 1 //設定オン「1」設定オフ「0」

    //制御したいセクションのID
    var section_id = "shopify-section-template--18688091586695__section_collection_H6YRCw";

    //表示期間の設定 ※必ず「06」頭の0をとらない！！！！
    var start_day = "2025-11-28";
    var start_time = "09:00";
    var end_day = "2025-11-28";
    var end_time = "09:54";

    ///***設定値*********************************************

    if(check_flg == 1){
        //セクションの取得
        const section = document.getElementById(section_id);

        // 表示期間の設定
        const startDate = new Date(start_day+"T"+start_time+":00+09:00");
        const endDate = new Date(end_day+"T"+end_time+":00+09:00");
        const now = new Date();

        if (now >= startDate && now <= endDate) {
            section.style.display = "block"; // 表示
        } else {
            section.style.display = "none"; // 非表示
        }
    }

});
// 期間表示設定はここまで





// 期間表示設定はここから　【抽選】
document.addEventListener("DOMContentLoaded", function () {

    ///***設定値*********************************************

    //設定のオンオフ
    var check_flg = 1 //設定オン「1」設定オフ「0」

    //制御したいセクションのID
    var section_id = "template--18688091586695__section_collection_KHaEN3";

    //表示期間の設定 ※必ず「06」頭の0をとらない！！！！
    var start_day = "2026-02-07";
    var start_time = "10:00";
    var end_day = "2026-02-13";
    var end_time = "23:59";

    ///***設定値*********************************************

    if(check_flg == 1){
        //セクションの取得
        const section = document.getElementById(section_id);

        // 表示期間の設定
        const startDate = new Date(start_day+"T"+start_time+":00+09:00");
        const endDate = new Date(end_day+"T"+end_time+":00+09:00");
        const now = new Date();

        if (now >= startDate && now <= endDate) {
            section.style.display = "block"; // 表示
        } else {
            section.style.display = "none"; // 非表示
        }
    }

});
// 期間表示設定はここまで
*/



// アーカイブページのjsここから

document.addEventListener('DOMContentLoaded', () => {

  const cards = document.querySelectorAll('.kl-achievement-card');
  const filter = document.getElementById('klAchievementFilter');
  const grid = document.querySelector('.kl-achievements-grid');

  if (!grid || cards.length === 0) return;

  const itemsPerPage = 21;
  let currentPage = 1;
  let filteredCards = [...cards];

  const pagination = document.createElement('div');
  pagination.className = 'kl-achievements-pagination';

  grid.after(pagination);

  function renderPage() {

    cards.forEach(card => {
      card.classList.add('is-hidden');
    });

    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;

    filteredCards.slice(start, end).forEach(card => {
      card.classList.remove('is-hidden');
    });

    renderPagination();
  }

  function renderPagination() {

    pagination.innerHTML = '';

    const totalPages = Math.ceil(filteredCards.length / itemsPerPage);

    if (totalPages <= 1) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'kl-pagination-info';

    const prevBtn = document.createElement('button');
    prevBtn.className = 'kl-pagination-btn';
    prevBtn.innerHTML = '‹';

    if (currentPage === 1) {
      prevBtn.disabled = true;
    }

    prevBtn.addEventListener('click', () => {
      if (currentPage > 1) {
        currentPage--;
        renderPage();

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    });

    wrapper.appendChild(prevBtn);

    function addPage(num) {

      const btn = document.createElement('button');

      btn.className = 'kl-page-number';

      if (num === currentPage) {
        btn.classList.add('is-active');
      }

      btn.textContent = num;

      btn.addEventListener('click', () => {

        currentPage = num;

        renderPage();

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

      });

      wrapper.appendChild(btn);
    }

    if (totalPages <= 5) {

      for (let i = 1; i <= totalPages; i++) {
        addPage(i);
      }

    } else {

      addPage(1);

      if (currentPage > 3) {

        const dots = document.createElement('span');
        dots.className = 'kl-page-ellipsis';
        dots.textContent = '...';
        wrapper.appendChild(dots);

      }

      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      for (let i = startPage; i <= endPage; i++) {
        addPage(i);
      }

      if (currentPage < totalPages - 2) {

        const dots = document.createElement('span');
        dots.className = 'kl-page-ellipsis';
        dots.textContent = '...';
        wrapper.appendChild(dots);

      }

      addPage(totalPages);

    }

    const nextBtn = document.createElement('button');
    nextBtn.className = 'kl-pagination-btn';
    nextBtn.innerHTML = '›';

    if (currentPage === totalPages) {
      nextBtn.disabled = true;
    }

    nextBtn.addEventListener('click', () => {

      if (currentPage < totalPages) {

        currentPage++;

        renderPage();

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

      }

    });

    wrapper.appendChild(nextBtn);

    pagination.appendChild(wrapper);
  }

if (filter) {
  filter.addEventListener('change', () => {

    const value = filter.value;

    if (value === 'all') {
      filteredCards = [...cards];
    } else {
      filteredCards = [...cards].filter(card => {
        return card.dataset.year === value;
      });
    }

    currentPage = 1;

    renderPage();

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

  });
}



  renderPage();



  if (window.innerWidth <= 767) {

    document.querySelectorAll('.kl-achievement-image-wrap').forEach((wrap) => {

      const slider = wrap.querySelector('.kl-achievement-image-slider');

      if (!slider) return;

      const dots = wrap.parentElement.querySelectorAll('.kl-achievement-dots span');

      const total = slider.querySelectorAll('img').length;

      if (total <= 1) return;

      let current = 0;

      let startX = 0;
      let moveX = 0;
      let isDragging = false;

      wrap.addEventListener('touchstart', (e) => {

        startX = e.touches[0].clientX;
        isDragging = true;

      });

      wrap.addEventListener('touchmove', (e) => {

        if (!isDragging) return;

        moveX = e.touches[0].clientX - startX;

      });

      wrap.addEventListener('touchend', () => {

        if (!isDragging) return;

        if (moveX < -50 && current < total - 1) {
          current++;
        }

        if (moveX > 50 && current > 0) {
          current--;
        }

        slider.style.transform = `translateX(-${current * (100 / total)}%)`;

        dots.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === current);
        });

        startX = 0;
        moveX = 0;
        isDragging = false;

      });

    });

  }

});// アーカイブページのjsここまで